import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IRSReport, LexNexReport, TinCheckReport } from '../classes/models';
import { GenericObject } from '../interfaces/generic-object';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(private http: HttpClient) {}

  getLexNexReport(query = {}) {
    return this.http.get<LexNexReport>(`/api/v2/admin/report/lexisNexis/one`, {
      params: query
    });
  }

  getIRSReport(query = {}) {
    return this.http.get<IRSReport>(`/api/v2/admin/report/irs/one`, {
      params: query
    });
  }

  getTinCheckReport(query = {}) {
    return this.http.get<TinCheckReport>(`/api/v2/admin/report/tinCheck/one`, {
      params: query
    });
  }

  generateInvoiceReport(ReportInfo: GenericObject, query = {}) {
    return this.http.post(
      `/api/v2/reportRetriever/generateInvoiceReport`,
      ReportInfo,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateSpotlightVendorKPIReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateSpotlightVendorKPIReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateSpotlightVendorsReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateSpotlightVendorsReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateSiteAssignedVendorsReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateSiteAssignedVendorsReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateSuspendedVendorsReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateSuspendedVendorsReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateTieredTradesReport(query = {}) {
    return this.http.get(`/api/v2/reportRetriever/generateTieredTradesReport`, {
      params: query,
      responseType: 'arraybuffer'
    });
  }

  generateTradesAndTradeCategoriesReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateTradesAndTradeCategoriesReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateVendorsInReviewReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateVendorsInReviewReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateVendorsRegisteredReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateVendorsRegisteredReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateVendorStatusesReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateVendorStatusesReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateVendorTradesReport(query = {}) {
    return this.http.get(`/api/v2/reportRetriever/generateVendorTradesReport`, {
      params: query,
      responseType: 'arraybuffer'
    });
  }

  generateVendorsExpiredInsuranceReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateVendorsExpiredInsuranceReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateComplianceSummaryReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateComplianceSummaryReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateBusinessVerifiedComplianceReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateBusinessVerifiedComplianceReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateComplianceDetailReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateComplianceDetailReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateFeeVouchersReport(query = {}) {
    return this.http.get(`/api/v2/reportRetriever/generateFeeVouchersReport`, {
      params: query,
      responseType: 'arraybuffer'
    });
  }

  generateInsuranceTypeAndDatesReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateInsuranceTypeAndDatesReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateAPInsuranceTypeAndDatesReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateAPInsuranceTypeAndDatesReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateLinkedVendorsReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateLinkedVendorsReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateVendorPaymentDetailReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateVendorPaymentDetailReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateVendorPaymentSummaryReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateVendorPaymentSummaryReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateBusinessVerifiedInvoicesReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateBusinessVerifiedInvoicesReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateBusinessVerificationOverrideReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateBusinessVerificationOverrideReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateSiteAssignmentsForAPReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateSiteAssignmentsForAPReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateNewlyApprovedVendorsReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateNewlyApprovedVendorsReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateAllActiveVendorsReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateAllActiveVendorsReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generatePaymentDetailReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generatePaymentDetailReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateClientFeeListReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateClientFeeListReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateComplianceSummaryBVOnlyReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateComplianceSummaryBVOnlyReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateInsuranceResultsReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateInsuranceResultsReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateClientNetIncomeReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateClientNetIncomeReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateComprehensiveBidReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateComprehensiveBidReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateBidComparisonReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateBidComparisonReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateBusinessVerificationReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateBusinessVerificationReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateExemptVendorTypesReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateExemptVendorTypesReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateFSRKPIReport(query = {}) {
    return this.http.get(`/api/v2/reportRetriever/generateFSRKPIReport`, {
      params: query,
      responseType: 'arraybuffer'
    });
  }

  generateFSRKPIQuarterlyReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateFSRKPIQuarterlyReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }

  generateConflictOfInterestReport(query = {}) {
    return this.http.get(
      `/api/v2/reportRetriever/generateConflictOfInterestReport`,
      { params: query, responseType: 'arraybuffer' }
    );
  }
}
